import { environment } from '../../../../../environments/environment'
import {
	Component,
	OnInit,
	ViewChild,
	Output,
	EventEmitter,
	Input
} from '@angular/core'
import { NotificationService } from 'src/app/services/notification.service'
import { NgForm } from '@angular/forms'
import { ImageGaleryInventory, InventoryDetailsSchedule } from 'src/app/models/Inventory'
import { InventoryService } from 'src/app/services/inventory.service'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { getLoggedUser } from 'src/app/_helpers/LocalStorage'
import { removeToolTip } from 'src/app/_helpers/Utils'

@Component({
	selector: 'app-schedule-inventory',
	templateUrl: './schedule-inventory.component.html'
})
export class ScheduleInventoryComponent implements OnInit {
	constructor(
		public notificationService: NotificationService,
		private inventoryService: InventoryService
	) { }

	@Input() public idMongo: string
	@Output() public getInventorys: any = new EventEmitter()
	@Output() public closeInventoryDetails: EventEmitter<any> = new EventEmitter()
	@Output() public removedInventory: EventEmitter<any> = new EventEmitter()

	public labelOptions: any = {
		url: 'assets/images/m1.svg',
		scaledSize: {
			width: 40,
			height: 40
		}
	}
	// @Input() public scheduler: SchedulerComponent
	@ViewChild('form') public form: NgForm
	public companyId: string = localStorage.getItem('companyId')
	public sessionUser: UserAdmin = getLoggedUser()
	public inventorySelected: InventoryDetailsSchedule

	public galeryInventory: Array<ImageGaleryInventory> = []
	public photoSelected: ImageGaleryInventory
	public carouselPages: number = 0
	public carouselPageNow: number = 1
	public arrowLeftEnable: boolean = false
	public arrowRightEnable: boolean = true
	public photoFromCarouselEnable: boolean = false
	public openDelete: boolean = false
	public enableSalveButton: boolean = false
	public loading: boolean = false
	public openModalCancelOperation: boolean = false
	public lastStepCancellation: boolean = false
	public isAdmin: boolean = false
	public justifyCancel: string = ''

	public async ngOnInit(): Promise<void> {
		this.isAdmin = Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))

		setTimeout(() => {
			window.scrollTo(0 , 0)
		}, 250)

		await this.setInventorySelected()
		await this.setGaleryInventory()
	}

	public async setInventorySelected() {
		this.inventorySelected =
			await this.inventoryService.getInventoryDetails(this.idMongo).toPromise()
	}

	public setGaleryInventory() {
		const treeMedia: ImageGaleryInventory = {
			photo: this.inventorySelected.treePhoto,
			evaluation: 'Foto da árvore'
		}

		this.galeryInventory.push(treeMedia)

		this.inventorySelected.inventorAnswers.forEach(answer => {
			if (answer.photo) {
				const galeryInventoryObj: ImageGaleryInventory = {
					photo: answer.photo,
					evaluation: answer.evaluation
				}

				this.galeryInventory.push(galeryInventoryObj)
			}
		})

		this.carouselPages = Math.floor(this.galeryInventory.length / 3)
	}

	public moveCarousel(direction: 'left' | 'right') {
		const carousel = document.getElementById('carousel-content') as HTMLDivElement
		const carouselWidth: number = 748

		if (direction == 'left') {
			if (this.carouselPageNow > 1) {
				this.carouselPageNow--
			}
		}
		if (direction == 'right') {
			if (this.carouselPageNow < this.carouselPages) {
				this.carouselPageNow++
			}
		}

		if (this.carouselPageNow > 1) {
			this.arrowLeftEnable = true
		} else {
			this.arrowLeftEnable = false
		}

		if (this.carouselPageNow == this.carouselPages) {
			this.arrowRightEnable = false
		} else {
			this.arrowRightEnable = true
		}

		const carouselPosition: number = carouselWidth * (this.carouselPageNow - 1)
		carousel.style.left = `-${carouselPosition}px`
	}

	public openClosePhotoFromCarousel(photo?: ImageGaleryInventory) {
		if (photo) {
			this.photoSelected = photo
			this.photoFromCarouselEnable = true
		} else {
			this.photoSelected = null
			this.photoFromCarouselEnable = false
			removeToolTip()
		}
	}

	public closeModal(): void {
		this.closeInventoryDetails.emit()
	}

	public openDeleteModal(): void {
		this.openDelete = true
	}

	public closeDeleteModal(): void {
		this.openDelete = false
	}

	public async removeInventory() {

		const response = await this.inventoryService.removeToPageSchedule(this.inventorySelected.idMongo).toPromise()
		this.notificationService.notify(response.message, 200)

		this.removedInventory.emit()
	}

	public initCancelSchedule() {
		const cancelAppraisal: boolean = Boolean(this.inventorySelected.os.isAppraisal)

		if (cancelAppraisal) {
			this.cancelScheduleAppraisal()
		} else {
			this.openModalCancelOperation = true
		}
	}

	public runLastStepCancellation() {
		this.lastStepCancellation = true
	}

	public openAlertModal() {
		this.openModalCancelOperation = !this.openModalCancelOperation
		this.lastStepCancellation = false
		this.justifyCancel = ''
	}

	public async cancelScheduleAppraisal(): Promise<void> {
		try {
			const response =
				await this.inventoryService.cancelScheduleForAppraisal(
					this.inventorySelected.os.idMongo
				).toPromise()

			this.notificationService.notify(response.message, 200)

			this.getInventorys.emit()

		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public async cancelScheduleOperation(): Promise<void> {
		try {
			const response = await this.inventoryService.cancelScheduleForOperation(
				this.inventorySelected.os.idMongo,
				this.justifyCancel
			).toPromise()

			this.notificationService.notify(response.message, 200)

			this.getInventorys.emit()

		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public async savePlanting() {
		try {
			const response: any = await this.inventoryService.updateInventory(
				this.inventorySelected
			).toPromise()

			this.notificationService.notify(response.message, 200)
			this.getInventorys.emit()
			this.closeModal()
		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public enableSalve() {
		if (!this.inventorySelected.address) {
			this.enableSalveButton = false
		} else {
			this.enableSalveButton = true
		}
	}
}
